/**
 * Checks if the current device is a touch device.
 *
 * @param $prediction - to prevent CLS issues
 */
export const isTouchDevice = ($prediction: boolean = false) => {
    if (typeof window === 'undefined') return $prediction

    return (
        'ontouchstart' in window ||
        (navigator.maxTouchPoints > 0 && navigator.maxTouchPoints !== 256)
    )
}
